<template>
    <div class="d-flex justify-content-end mr-4">
        <Button @click="dialogs.filter = true" type="outline" color="grey" class="filter-button mx-1 px-3 py-2">
            <FilterIcon class="ml-0" size="16" color="#A1A8B8" />
            <span>Filtrar</span>
            <span :class="`badge ${getPrimaryColor} filter-selected badge-filter-button-position ml-1`" v-if="renderFilterBadgeNotificationNumber">{{ renderFilterBadgeNotificationNumber }}</span>
        </Button>
        <FiltersModal
            :dialogVisible="dialogs.filter"
            :disableButton="!filterChanged"
            @filter="handleFilter"
            @empty="emptyAllFilters"
            @closeModal="dialogs.filter = $event"
        >
            <el-collapse  >
                <FilterCollapseItem
                    v-if="hasFilter('withECPF')"
                    name="1"
                    itemTitle="Sócio com e-CPF"
                    type="radio"
                    :renderBadgeCondition="innerFilter.withECPF"
                    :filter="innerFilter.withECPF"
                    :radioItems="filterItems.itemsECPF"
                    @returnedFilter="handleReturnedFilter($event)"
                />
                <FilterCollapseItem
                    v-if="hasFilter('totalValue')"
                    name="2"
                    itemTitle="Total disponível (R$)"
                    type="input"
                    :renderBadgeCondition="
                        innerFilter.totalValue 
                        ? 
                        innerFilter.totalValue.minValue && innerFilter.totalValue.maxValue
                        : false
                    "
                    :filter="innerFilter.totalValue"
                    :example="1000"
                    @returnedFilter="handleReturnedFilter($event)"
                />
            </el-collapse>
        </FiltersModal>
    </div>
</template>

<script>
import _ from 'lodash'

import FilterCollapseItem from '@/components/filters/components/FilterCollapseItem'
import { FILTER_ITEMS } from '@/utils/constants'

import { cleanObject } from '@/utils/cleanner'

const FILTER_KEY_NAME_CORRELATION = {
    1: 'withECPF',
    2: 'totalValue',
}

export default {
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            innerFilter: _.cloneDeep(this.filters),
            dialogs: {
                filter: false
            },
            filterChanged: false,

        }
    },
    components: {
        FilterCollapseItem,
    },
    methods: {
        hasFilter(filter){
            const filterKeys = Object.keys(this.innerFilter)
            const includes = filterKeys.includes(filter)

            return includes
        },
        handleReturnedFilter(returnedFilter){
            const { correlation, filter } = returnedFilter
            this.innerFilter[FILTER_KEY_NAME_CORRELATION[correlation]] = filter

            if(!_.isEqual(this.innerFilter, this.filters)){
                this.filterChanged = true
            }
        },
        handleFilter() {
            const filterValues = Object.entries(_.cloneDeep(this.innerFilter))

            filterValues.forEach(([key, value]) => {               
                if (
                    value 
                    && value.maxValue 
                    && value.minValue 
                    && parseInt(value.minValue) >= parseInt(value.maxValue)
                ) {
                    this.innerFilter[key].maxValue = value.minValue
                    this.innerFilter[key].minValue = value.maxValue
                }     
            })

            this.$emit('updateFilter', _.cloneDeep(this.innerFilter))
            this.dialogs.filter = false
        },
        emptyAllFilters() {
            const cloneFilter = _.cloneDeep(this.innerFilter)
            this.innerFilter = cleanObject(cloneFilter)
            this.$emit('empty', _.cloneDeep(this.innerFilter))
            this.dialogs.filter = false
        },
    },
    computed: {
        filterItems(){
            const { ECPF } = FILTER_ITEMS

            return { itemsECPF: ECPF }
        },
        renderFilterBadgeNotificationNumber() {
            const filtersValues = Object.values(this.filters)
            
            const numberOfFilters = filtersValues.filter((filtersValue) => {
                if(filtersValue === null) return false

                if(typeof filtersValue === 'object') {
                    return (filtersValue.start && filtersValue.end) || (filtersValue.minValue && filtersValue.maxValue)
                }
                
                return true
            })

            return numberOfFilters.length;
        },
    },
}
</script>

<style>

</style>